import reducer from 'circe/listing/reducer';
import actionTypes from './actionTypes';

const listingReducer = reducer(actionTypes);

export default (state, action) => {
  switch (action.type) {
    // custom actions

    default:
      return listingReducer(state, action);
  }
};
